"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseQuery = void 0;
const abstract_query_1 = require("../abstract/abstract-query");
/**
 * This is the base query of the OpenSearch query. This helps in defining first-level properties such as `size`, `aggregations`, and `query`.
 */
class BaseQuery extends abstract_query_1.AbstractQuery {
}
exports.BaseQuery = BaseQuery;
